<template>
  <section>
    <div class="container">
      <custom-title-block :title="title" :subtitle="subtitle" />
      <div class="content">
        <project-video-block :video-title="videoTitle" />
        <project-text-block
          :text-title="textTitle"
          :guarantee-text="guaranteeText"
        />
      </div>
    </div>
  </section>
</template>

<script>
import CustomTitleBlock from "@/components/UI/CustomTitle.vue";
import ProjectVideoBlock from "@/components/main/aboutProject/modules/ProjectVideoBlock.vue";
import ProjectTextBlock from "@/components/main/aboutProject/modules/ProjectTextBlock.vue";

export default {
  name: "about-project",
  components: {
    ProjectTextBlock,
    ProjectVideoBlock,
    CustomTitleBlock,
  },
  data() {
    return {
      title: "Drone Force",
      subtitle:
        "Центр рекрутингу та підготовки фахівців безпілотних систем Сухопутних військ",
      videoTitle:
        "З нами ти зможеш долучитися до одного з підрозділів Сухопутних військ та опанувати найсучаснішу " +
        "професію у війську – стати оператором БпЛА, НРК або іншим фахівцем безпілотних систем",
      textTitle:
        "Ми пропонуємо пройти відбір та підготовку в найтехнологічнішу частину війська з найкращими можливостями",
      guaranteeText: [
        "Гарантована посада фахівця безпілотних систем",
        "Можливість обрати підрозділ та напрямок фаху",
        "Супровід на етапі оформлення документів та навчання",
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  gap: 20px;
  justify-content: space-between;

  @media (max-width: 1360px) {
    flex-direction: column;
  }
}
</style>
